import React, { useState, useEffect } from 'react';
import Image01 from './01.jpg';
import Image02 from './02.jpg';
import Image03 from './03.jpg';
import Image04 from './04.jpg';

const ImageSlideShow = () => {
  const images = [
    Image01,
    Image02,
    Image03,
    Image04,
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <img
      src={images[currentIndex]}
      alt={`Slide ${currentIndex + 1}`}
      className="slideshow-image"
    />
  );
};

export default ImageSlideShow;
